import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import config from '@/config';
import api from '@/shared/api';
import DataCacheService from '@/shared/services/DataCacheService';
import ToastrService from '@/shared/services/ToastrService';
import { useIntl } from 'react-intl';
import moment from 'moment';
import DocumentDetailsModal from './details/DocumentDetailsModal';
import messages from './documentMessages';
import HandleHttpError from '@/shared/services/HandleHttpError';

const CheckoutReminderMode = ({ onDocumentSaved }) => {
  const [documents, setDocuments] = useState([]);
  const intl = useIntl();

  useEffect(() => {
    let abort = false;
    const cancelToken = Axios.CancelToken.source();
    var shouldShowReminders =
      DataCacheService.getDefaultCompany()?.shouldShowCheckoutReminders ?? false;
    if (!shouldShowReminders) return;

    api.base
      .get(`${config.appUrls.documents}/api/documents/checkedout`, {
        params: {},
        cancelToken: cancelToken.token,
      })
      .then(({ data }) => {
        if (abort || !data) return;
        setDocuments(data || []);
      })
      .catch(error => {
        if (!Axios.isCancel(error)) return HandleHttpError(intl)(error);
      });

    return () => {
      abort = true;

      cancelToken.cancel('Operation canceled due to new request.');
    };
  }, []);

  const removeDocumentFromList = document => {
    setDocuments(documents.filter(x => x !== document.id));
    onDocumentSaved(document);
  };
  const cancel = () => {
    ToastrService.info(intl.formatMessage(messages.CheckedOutDocumentsReminderMessage));
    setDocuments([]);
  };

  if (documents.length === 0) return null;

  const activeDocument = documents[0];
  return (
    <div key={activeDocument}>
      <DocumentDetailsModal
        show
        documentId={activeDocument}
        allowNavigation={false}
        onSave={document => removeDocumentFromList(document)}
        onClose={() => cancel()}
        checkedoutReminderMode={true}
      />
    </div>
  );
};

export default CheckoutReminderMode;
